import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useRacing } from "../context/RacingContext";
import { useAuth } from "../context/AuthContext";
import { RunForm } from "../components/RunForm";
import { Button } from "../components/ui/button";
import { toast } from "sonner";
import { ArrowLeft, Trash2 } from "lucide-react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "../components/ui/alert-dialog";

export default function RunDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { runs, updateRun, deleteRun, loaded } = useRacing();
  const { user } = useAuth();
  const locked = user?.trialLocked;
  const run = runs.find((r) => r.id === id);

  if (loaded && !run) {
    return (
      <div className="mx-auto max-w-3xl py-16 text-center">
        <p className="text-mt-mutedfg">Run not found.</p>
        <Button onClick={() => navigate("/history")} className="mt-4 bg-mt-primary text-white">Back to History</Button>
      </div>
    );
  }
  if (!run) return <p className="py-16 text-center text-mt-mutedfg">Loading…</p>;

  const handleSubmit = async (updated) => {
    await updateRun(id, updated);
    toast.success("Run updated");
    navigate("/history");
  };

  const handleDelete = async () => {
    await deleteRun(id);
    toast.success("Run deleted");
    navigate("/history");
  };

  return (
    <div className="mx-auto max-w-3xl">
      <div className="mb-4 flex items-center justify-between">
        <button onClick={() => navigate(-1)} data-testid="back-button" className="flex items-center gap-1 text-sm font-semibold text-mt-primary hover:underline">
          <ArrowLeft size={16} /> Back
        </button>
        <AlertDialog>
          <AlertDialogTrigger asChild>
            <Button variant="outline" data-testid="delete-run-button" disabled={locked} className="gap-2 border-mt-border text-mt-text">
              <Trash2 size={16} /> Delete
            </Button>
          </AlertDialogTrigger>
          <AlertDialogContent className="bg-mt-card">
            <AlertDialogHeader>
              <AlertDialogTitle>Delete this run?</AlertDialogTitle>
              <AlertDialogDescription>This permanently removes the run from your history.</AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel data-testid="delete-cancel">Cancel</AlertDialogCancel>
              <AlertDialogAction onClick={handleDelete} data-testid="delete-confirm" className="bg-mt-text text-white hover:bg-mt-text/90">Delete</AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      </div>

      <h1 className="mb-1 font-head text-3xl font-black tracking-tighter">Edit Run</h1>
      <p className="mb-6 text-sm text-mt-mutedfg">{run.track} · {run.date}</p>
      <RunForm initial={run} onSubmit={handleSubmit} submitLabel="Update Run" disabled={locked} />
    </div>
  );
}
